import { disclaimerHeading, disclaimerPanel, disclaimerSection, link } from './nearbySchoolsModule.styles';

export const RatingsDisclaimer = () => {
  return (
    <div className={disclaimerPanel}>
      <h2 className={disclaimerHeading}>About the ratings</h2>
      <p className={disclaimerSection}>
        Historically,{' '}
        <a href="https://www.greatschools.org/gk/ratings/" target="_blank" rel="noopener noreferrer" className={link}>
          GreatSchools
        </a>{' '}
        ratings have been based solely on a comparison of standardized test results for all schools in a given state. As
        of September 2017, the GreatSchools ratings also incorporate additional information, when available, such as
        college readiness, academic progress, advanced courses, equity, discipline and attendance data. GreatSchools
        ratings are designed to be a starting point to help parents compare schools, and they should not be the only
        factor used in selecting the right school for your family.
      </p>
      <p className={disclaimerSection}>
        <strong>Disclaimer:</strong> School attendance zone boundaries are provided by a third party and subject to
        change. Check with applicable school district prior to making a decision based on these boundaries. In addition,
        school data is obtained from a third party vendor and not guaranteed to be accurate, up to date or complete.
      </p>
    </div>
  );
};
